import { jsx } from '@amazon/vinyl-tsx'
import { Shoveler, type ShovelerProps } from '@/components/Shoveler'
import {
    type RecommendationModel,
    RecommendationRenderer,
    type RecommendationRendererDeps,
} from '@/browse/RecommendationRenderer'
import { omit } from '@/util/objectUtil'

export type PlayableEntitiesListProps = ShovelerProps & {
    readonly data: readonly RecommendationModel[]
    readonly imageSize: number
    readonly deps: RecommendationRendererDeps
}

export function RecommendationsShoveler(props: PlayableEntitiesListProps) {
    return (
        <Shoveler {...omit(props, ['data', 'imageSize'])}>
            {...props.data.map((entity) => (
                <RecommendationRenderer
                    data={entity}
                    imageSize={props.imageSize}
                    deps={props.deps}
                />
            ))}
        </Shoveler>
    )
}
